module.exports = __webpack_public_path__ + "static/media/noimage.cae14775.svg";